import Skeleton from "react-loading-skeleton";
import {
  BranchContentSkeleton,
  BranchHeroSkeleton,
  BranchMetaSkeleton,
  DarkSkeletonTheme,
  TextBlock,
  UniformeSkeleton,
} from "./shared";

type BranchDetailSkeletonProps = {
  withUniforme?: boolean;
  withPdf?: boolean;
};

const BranchDetailSkeleton = ({
  withUniforme = false,
  withPdf = false,
}: BranchDetailSkeletonProps) => (
  <DarkSkeletonTheme>
    <div className="mt-24 lg:mt-40" aria-busy="true" aria-live="polite">
      <BranchHeroSkeleton />
      <BranchMetaSkeleton />
      <BranchContentSkeleton lines={withPdf ? 10 : 8} />
      {withPdf && (
        <section className="bg-empty pt-16 pb-10 px-10 lg:px-24">
          <div className="mb-8">
            <Skeleton height={28} width={280} />
          </div>
          <TextBlock lines={4} />
          <div className="mt-8 mx-auto w-full max-w-[500px]">
            <div className="aspect-[500/800] w-full max-w-full">
              <Skeleton className="!h-full !w-full !max-w-full" />
            </div>
            <div className="mt-4 flex justify-center gap-3">
              <Skeleton height={36} width={120} />
            </div>
            <div className="mt-4 flex justify-center">
              <Skeleton height={22} width={160} />
            </div>
          </div>
        </section>
      )}
      {withUniforme && <UniformeSkeleton />}
    </div>
  </DarkSkeletonTheme>
);

export default BranchDetailSkeleton;
